import React from 'react';

interface IconProps {
  className?: string;
}

export const DatadogIcon: React.FC<IconProps> = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-.5 4C8.567 6 6 8.567 6 11.5S8.567 17 11.5 17s5.5-2.567 5.5-5.5S14.433 6 11.5 6zm0 2c1.933 0 3.5 1.567 3.5 3.5S13.433 15 11.5 15 8 13.433 8 11.5 9.567 8 11.5 8z"/>
  </svg>
);

export const AWSIcon: React.FC<IconProps> = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M18.75 11.35a4.32 4.32 0 0 1-.79-.08 3.9 3.9 0 0 1-.73-.23l-.17-.07v1.46l.13.05a5 5 0 0 0 .89.26 4.27 4.27 0 0 0 .88.09 3.31 3.31 0 0 0 2.21-.67 2.33 2.33 0 0 0 .8-1.85 2 2 0 0 0-.47-1.43 3.14 3.14 0 0 0-1.42-.78l-.5-.18a2.06 2.06 0 0 1-.86-.44.83.83 0 0 1-.21-.59.81.81 0 0 1 .35-.67 1.5 1.5 0 0 1 .9-.26 3 3 0 0 1 1.53.44l.14.08V5.82l-.12-.05a4.24 4.24 0 0 0-.72-.22 4.28 4.28 0 0 0-.87-.09 3.07 3.07 0 0 0-2.08.68A2.36 2.36 0 0 0 17 8a2.08 2.08 0 0 0 .42 1.33 2.83 2.83 0 0 0 1.29.79l.52.18c.45.16.75.31.9.47a.82.82 0 0 1 .23.6.85.85 0 0 1-.38.74 1.82 1.82 0 0 1-1.05.27v-.03z M5.34 12.41l-1.53 4.36h-.95L4.05 13l-1.11-3.75h1l.72 2.9.71-2.9h.95l.71 2.9.72-2.9h1L7.64 13l1.19 3.75h-.95l-1.53-4.36-.5 1.64-.51-1.62z M13.47 16.77h-1V9.27h1v7.5z M24 16.77h-1.09l-2.24-3.46-2.25 3.46h-1.07l2.78-4.13-2.55-3.37h1.08l2 3.05 2-3.05h1.08L21.21 12.64l2.79 4.13z"/>
  </svg>
);

export const HerokuIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.61 0H3.39C2.16 0 1.16 1 1.16 2.23v19.54C1.16 23 2.16 24 3.39 24h17.22c1.23 0 2.23-1 2.23-2.23V2.23C22.84 1 21.84 0 20.61 0zM19 20.34h-3.03v-6.9c0-.62-.18-1.06-.54-1.32-.36-.26-.91-.39-1.64-.39-.52 0-1.02.07-1.5.2-.48.13-.91.3-1.29.5v7.91H7.97V3.63H11v5.76c.43-.22.91-.39 1.45-.52.54-.13 1.13-.19 1.77-.19 1.52 0 2.7.36 3.54 1.08.83.72 1.25 1.83 1.25 3.34v7.24H19zM6.45 20.34H3.42V3.63h3.03v16.71z" />
  </svg>
);
